import React from 'react';
import * as ds from './dataService';
import { appFormUtil } from 'modules/common';
import { StyledDropDown } from 'modules/components/layer01';
import { useParams } from 'react-router-dom';



export type SelectInstallationRoomFieldProps<T extends object> = appFormUtil.SelectFieldProps<T> & {
  inputLabel?: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: SelectInstallationRoomFieldProps<T>) => {
  const params = useParams();
  const { data } = ds.useQuery(params.projectId ?? '');
  return (
    <StyledDropDown.FC
      {...props.form.genFieldProps(props.fieldName)}
      options={data}
      inputLabel={props.inputLabel}
    />
  );
};
